@if (placeholder) {
  <div class="chart-placeholder" [style.height]="height">
    @for (group of placeholderColumns; track $index) {
      <span class="chart-placeholder-group">
        @for (bar of group; track $index) {
          <span class="chart-placeholder-bar" [style.height.%]="bar"></span>
        }
      </span>
    }
  </div>
} @else {
  @if (title) {
    <h3 class="h3 mbl">{{ title }}</h3>
  }
  @if (columnOptions) {
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="columnOptions"
      (chartInstance)="onChartInstance($event)"
      style="display: block; width: 100%"
    ></highcharts-chart>
  }
}
